/**
 * Faqja e plotë "Unë" (mobile) – si cloud Me.js: listë kartash, light + dark.
 */
import { Link, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

const APP_VERSION = process.env.REACT_APP_VERSION || '1.02';

const MePage = () => {
  const { user, logout } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'SUPERADMIN';
  const isSuperAdmin = user?.role === 'SUPERADMIN';
  const allowedPaths =
    user?.allowed_routes && Array.isArray(user.allowed_routes) && user.allowed_routes.length > 0
      ? user.allowed_routes
      : null;
  const canShow = (path) => allowedPaths === null || allowedPaths.includes(path);

  const handleLinks = () => {
    window.open('https://www.dio-iot.com', '_blank', 'noopener,noreferrer');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const cardClass =
    'flex items-center gap-3 w-full px-4 py-2.5 rounded-xl bg-white dark:bg-[#1e293b] border border-gray-200 dark:border-[#334155] hover:bg-gray-50 dark:hover:bg-[#2d3a4f] text-left text-gray-800 dark:text-white transition';
  const iconClass = 'w-5 h-5 shrink-0 text-gray-600 dark:text-gray-400';
  const arrow = (
    <svg className="w-5 h-5 shrink-0 text-gray-500 dark:text-gray-400 ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  );

  const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim() || user?.username || '–';

  return (
    <Layout>
      <div className="min-h-screen bg-gray-100 dark:bg-[#0f172a] pb-24 md:pb-6">
        <div className="mx-auto max-w-lg px-4 pt-4">
          {canShow('/settings') ? (
            <Link to="/settings" className={`${cardClass} mb-3`}>
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-200 dark:bg-[#334155]">
                <svg className="h-6 w-6 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate font-medium text-gray-900 dark:text-white">{fullName}</p>
              </div>
              {arrow}
            </Link>
          ) : (
            <div className={`${cardClass} mb-3 cursor-default`}>
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-200 dark:bg-[#334155]">
                <svg className="h-6 w-6 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate font-medium text-gray-900 dark:text-white">{fullName}</p>
              </div>
            </div>
          )}

          <div className="space-y-2">
            {canShow('/reports') && (
              <Link to="/reports" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <span>{t('reports')}</span>
                {arrow}
              </Link>
            )}

            {canShow('/alarms') && (
              <Link to="/alarms" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
                <span>{t('alarms')}</span>
                {arrow}
              </Link>
            )}

            {canShow('/analysis') && (
              <Link to="/analysis" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
                <span>{t('analysis')}</span>
                {arrow}
              </Link>
            )}

            {isAdmin && canShow('/users') && (
              <Link to="/users" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
                <span>{t('users')}</span>
                {arrow}
              </Link>
            )}

            {isSuperAdmin && canShow('/companies') && (
              <Link to="/companies" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                <span>{t('companies')}</span>
                {arrow}
              </Link>
            )}

            {isAdmin && canShow('/production-planning') && (
              <Link to="/production-planning" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span>{t('planning')}</span>
                {arrow}
              </Link>
            )}

            {isAdmin && canShow('/control') && (
              <Link to="/control" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <span>{t('control')}</span>
                {arrow}
              </Link>
            )}

            <button type="button" onClick={handleLinks} className={cardClass}>
              <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.172-1.172a4 4 0 001.172-2.828z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
              <span>{t('links')}</span>
              {arrow}
            </button>

            {canShow('/about') && (
              <Link to="/about" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>{t('about')}</span>
                <span className="ml-auto text-sm text-gray-600 dark:text-gray-400">{APP_VERSION}</span>
              </Link>
            )}

            {canShow('/alarms') && (
              <Link to="/alarms?section=notifications" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
                <span>{t('notifications')}</span>
                {arrow}
              </Link>
            )}

            {canShow('/settings') && (
              <Link to="/settings" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>{t('systemSettings')}</span>
                {arrow}
              </Link>
            )}
          </div>

          <button
            type="button"
            onClick={handleLogout}
            className="mt-5 w-full rounded-xl border border-gray-200 bg-white py-2.5 font-medium text-red-600 transition hover:bg-gray-50 dark:border-[#334155] dark:bg-[#1e293b] dark:text-red-400 dark:hover:bg-[#2d3a4f]"
          >
            {t('logout').toUpperCase()}
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default MePage;
